var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const Svg3Pie2 = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Salida-datos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inicio-selecci\\xF3n-multiple-de-eventos-copy-17",
    transform: "translate(-1218.000000, -139.000000)",
    fill: "#939393"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1225.71423,138.999879 L1225.71448,142.522056 C1223.25721,143.108357 1221.42857,145.33844 1221.42857,148 C1221.42857,150.66156 1223.25721,152.891643 1225.71448,153.477944 L1225.71423,157.000121 C1221.35274,156.369838 1218,152.580467 1218,148 C1218,143.419533 1221.35274,139.630162 1225.71423,138.999879 Z M1236,148 C1236,152.580467 1232.64726,156.369838 1228.28577,157.000121 L1228.28552,153.477944 C1230.74279,152.891643 1232.57143,150.66156 1232.57143,148 C1232.57143,145.33844 1230.74279,143.108357 1228.28552,142.522056 L1228.28577,138.999879 C1232.64726,139.630162 1236,143.419533 1236,148 Z",
    id: "Combined-Shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg3Pie2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/3_Pie2.658e4459.svg";
export { ForwardRef as ReactComponent };